/* TODO
  Translate publication ID to name
  Dynamically build the URL in the controller?
*/

import template from './pitchInfo.html';

function pitchInfo($compile) {
  function pitchInfoLink($scope, $element) {
    // let el;
    $scope.showForm = false;
    $scope.showInfo = false;

    const tagName = 'channel-pitch-update-form';

    const formTemplate = [
      '<channel-pitch-update-form pitch="pitch" on-complete="toggleForm()">',
      '</channel-pitch-update-form>'
    ].join('');

    function addForm() {
      $scope.pitch.newStatus = $scope.pitch.currentStatus;
      const el = $compile(formTemplate)($scope);
      // if want to append to the READ ONLY section, use: $element.parent()
      $element.append(el);

      $scope.showForm = true;
    }

    function removeForm() {
      $scope.showForm = false;
      $element.find(tagName).remove();
    }

    $scope.toggleForm = () => {
      if ($scope.showForm) {
        removeForm();
      } else {
        addForm();
      }
    };

    $scope.toggleInfo = () => {
      $scope.showInfo = !$scope.showInfo;
    };
  }

  return {
    restrict: 'E',
    template,
    controller: 'PitchInfoController',
    scope: {
      pitch: '=',
      edit: '&'
    },
    link: pitchInfoLink
  };
}

function PitchInfoController(
  $scope,
  $state,
  $injector,
  $compile,
  $uibModalStack,
  moment
) {
  $scope.platformPitch = $scope.pitch.type === 'platform';
  $scope.pitchedTo = $scope.platformPitch ? $scope.pitch.planPath : $scope.pitch.publicationId;
  $scope.starting = moment().unix();
  $scope.close = () => {
    $uibModalStack.dismissAll();

    const queryParams = {
      pl: $scope.pitch.planPath,
      sec: null
    };
    $state.go('planning.list', queryParams);
  };
}

const directiveArr = [
  '$compile',
  pitchInfo
];

const controllerArr = [
  '$scope',
  '$state',
  '$injector',
  '$compile',
  '$uibModalStack',
  'moment',
  'featureFlag',
  PitchInfoController
];

export default (ngModule) => {
  ngModule.directive('pitchInfo', directiveArr);
  ngModule.controller('PitchInfoController', controllerArr);
};
